// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallActivityBillableType {
    BasedOnServiceCallType = "O",
    Never = "N",
    Always = "T",
}

export let nameof = "ServiceCallActivityBillableType";
